import router from '@/router';
import { AxiosResponse } from 'axios';
import { loadCommonConfKeys } from '../../loader';
import { CONFIG_KEYS } from '@/store/modules/system';

const COMMON_CONF_KEYS = [...loadCommonConfKeys, ...Object.values(CONFIG_KEYS)];

const GET_DEV_CONF_URL = '/api/v2/configuration/get_dev_conf';
const GET_CONF_LIST_URL = '/api/v2/configuration/get_conf_list';

interface ConfItem {
  conf_value: string;
  conf_desc: string;
  conf_type: number;
}
class SwitchManager {
  private static instance: SwitchManager;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}
  private commonConfKeys: Record<string, ConfItem> = {};
  private confKeysByModule: Record<string, Record<string, ConfItem>> = {};

  public static getInstance(): SwitchManager {
    if (!SwitchManager.instance) {
      SwitchManager.instance = new SwitchManager();
    }
    return SwitchManager.instance;
  }

  public interceptResponse = (response: AxiosResponse) => {
    const { url } = response.config;
    if (url === GET_DEV_CONF_URL) {
      if (response.data.retcode === 0 && response.config.params?.conf_key) {
        this.setConfKeys(response.config.params.conf_key, response.data.data);
      }
    } else if (url === GET_CONF_LIST_URL) {
      if (response.data.retcode === 0) {
        response.data.data?.conf_list?.forEach((item) => {
          this.setConfKeys(item.conf_key, item);
        });
      }
    }
    return response;
  };
  private setConfKeys(confKey: string, confItem: any) {
    if (COMMON_CONF_KEYS.includes(confKey) || !router.currentRoute.name) {
      return;
      // 这里不设置 commonConfKeys 是因为 commonConfKeys 是全局配置，不需要根据路由设置
      // this.commonConfKeys[confKey] = {
      //   conf_value: confItem?.conf_value,
      //   conf_desc: confItem?.conf_desc,
      //   conf_type: confItem?.conf_type,
      // };
    } else {
      if (!this.confKeysByModule[router.currentRoute.name]) {
        this.confKeysByModule[router.currentRoute.name] = {};
      }
      this.confKeysByModule[router.currentRoute.name][confKey] = {
        conf_value: confItem?.conf_value,
        conf_desc: confItem?.conf_desc,
        conf_type: confItem?.conf_type,
      };
    }
  }
  public getCommonConfKeys() {
    return this.commonConfKeys;
  }
  public getConfKeys() {
    return this.confKeysByModule[router.currentRoute.name ?? ''] ?? {};
  }
}

export const switchManager = SwitchManager.getInstance();
